export default {"src":"/_next/static/media/SubDesc4.2cfc5e9b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};